<template>
  <div>
    <div v-if="!registerType">
      {{ $t("firstPasswordRegistration.rules.description") }}
    </div>

    <div v-for="(rule, key) in rules" :key="key" class="d-flex align-center">
      <v-icon
        v-if="!registerType"
        class="pr-1"
        :color="rule.error ? 'red lighten-1' : 'green'"
      >
        {{ rule.error ? "mdi-close" : "mdi-check" }}
      </v-icon>
      <span
        :class="[
          registerType ? 'caption' : '',
          rule.error ?
            'red--text text--lighten-1' :
            'green--text'
        ]"
      >
        {{ $t(rule.message) }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "passwordRules",

  props: {
    rules: {
      type: Object,
    },
    registerType: {
      type: Boolean,
    },
  },
};
</script>
